import gql from "graphql-tag";

export const MY_TAX_CREATE_TWO_CHILDREN_DECLARATION = gql`
  mutation createTaxDeclarationTwoChildren(
    $dateOfDeclaration: Date!
    $isModifiedDeclaration: Boolean!
    $isEligibleTwo: Boolean
    $isEligibleThree: Boolean
    $isEligible: Boolean
    $permanentlyEntitled: Boolean!
    $notApplyFromMonth: String!
    $dependents: [TaxDeclarationFourChildrenDependentInput]
  ) {
    createTaxDeclarationTwoChildren(
      dateOfDeclaration: $dateOfDeclaration
      isModifiedDeclaration: $isModifiedDeclaration
      isEligibleTwo: $isEligibleTwo
      isEligibleThree: $isEligibleThree
      isEligible: $isEligible
      permanentlyEntitled: $permanentlyEntitled
      notApplyFromMonth: $notApplyFromMonth
      dependents: $dependents
    ) {
      result
      messages
      tableId
    }
  }
`;
